import { useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { GoCheck } from 'react-icons/go';
import { ACTIVE_NETWORKS, ChainId, NETWORK_LOGOS } from '@shared/utils/config/networks';
import classNames from '@/lib/misc/classNames';
import { getNetworkName } from '@/lib/misc/utils';
import HistoryFilters from '@/components/home/mobile/History/HistoryFilters';
import { BiFilterAlt } from 'react-icons/bi';
import CustomDialog from '@/components/ui/customDialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import Image from 'next/image';
import { ImageWithFallback } from '@/components/shared/NextImageFallback';
export const DTPortfolioHeader = ({
  assetData,
  selectedNetwork,
  setSelectedNetwork,
  selectedTap,
  setSelectedTap
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  function toggleModal() {
    setIsModalOpen(!isModalOpen);
  }
  const networks = [{
    networkName: 'All Networks',
    totalUsdValue: assetData?.totalUsdValue,
    totalUsdRate: 100,
    chainId: 'all-networks'
  }, ...(Array.isArray(assetData?.balancesByChain) ? assetData.balancesByChain.map(chain => ({
    networkName: chain.networkName || 'Unknown Network',
    totalUsdValue: chain?.totalUsdValue,
    totalUsdRate: chain.totalUsdRate,
    chainId: chain.chainId,
    networkLogo: NETWORK_LOGOS[chain.chainId] || '/static/images/defaultnetwork.png'
  })) : [])].filter(x => {
    return ACTIVE_NETWORKS?.includes(x.chainId);
  });
  const chainOrder = Object.values(ChainId);
  const getChainOrder = chainId => {
    const index = chainOrder.indexOf(chainId);
    return index !== -1 ? index : chainOrder.length;
  };
  const sortedNetworks = networks.sort((a, b) => {
    if (a.chainId === 'all-networks') return -1;
    if (b.chainId === 'all-networks') return 1;
    return getChainOrder(a.chainId) - getChainOrder(b.chainId);
  });
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };
  const selectedNetworkWithData = networks.find(network => network.networkName === selectedNetwork?.name);
  return <div className='w-full bg-black text-genius-cream relative overflow-hidden h-[70px] rounded-t-[20px] mb-[-18px] pt-1 border-genius-blue border-[1px] ' data-sentry-component="DTPortfolioHeader" data-sentry-source-file="DTPortfolioHeader.tsx">
      <div className={`py-2 px-2 w-full flex justify-between`}>
        <div className='flex items-center gap-3 pl-2'>
          <div className='cursor-pointer'>
            <p onClick={() => setSelectedTap('holdings')} className={`text-[20px]  ${selectedTap === 'holdings' ? 'text-genius-cream' : 'text-genius-cream/50'} `}>
              Portfolio
            </p>
          </div>
          <div className='cursor-pointer'>
            <p onClick={() => setSelectedTap('trades')} className={`text-[20px] ${selectedTap === 'trades' ? 'text-genius-cream' : 'text-genius-cream/50'}`}>
              History
            </p>
          </div>
        </div>
        <div className='flex items-center gap-3'>
          {selectedTap === 'holdings' && <div onClick={toggleDropdown} className={classNames('whitespace-nowrap	font-light w-fit cursor-pointer flex items-center bg-genius-blue px-2 py-1 rounded-full text-[14px] h-fit')}>
              <Image src={selectedNetwork.logo || '/static/genius.png'} width={16} height={16} alt={`${selectedNetwork.name} logo`} className='mr-2' />

              {getNetworkName(selectedNetwork.name)}
              <IoIosArrowDown className='h-4 w-4 ml-2' />
            </div>}

          {selectedTap === 'trades' && <HistoryFilters isModalOpen={isModalOpen} toggleModal={toggleModal} isMobile={false} />}
        </div>

        {/* TOTAL BALANCE IN NETWORK
                 <div className={classNames('flex flex-col items-end w-2/4', desktop && 'w-5/12')}>
                    <p className='flex items-center font-light'>
                        {selectedNetworkWithData?.totalUsdValue && !isSwap
                            ? `$${toSpecialFixed(selectedNetworkWithData?.totalUsdValue).value}`
                            : ''}
                    </p>
                </div> */}
      </div>

      <CustomDialog className={'h-[420px] w-[400px] pt-8 px-0'} isOpen={isDropdownOpen} toggleModal={toggleDropdown} data-sentry-element="CustomDialog" data-sentry-source-file="DTPortfolioHeader.tsx">
        <div>
          <ScrollArea className='h-[420px] pb-10' data-sentry-element="ScrollArea" data-sentry-source-file="DTPortfolioHeader.tsx">
            <ul className='w-full mt-2'>
              <li className='px-4 cursor-pointer hover:bg-genius-blue flex justify-between items-center h-[45px]' onClick={() => {
              setSelectedNetwork({
                name: 'All Networks',
                value: `$${assetData?.totalUsdValue?.toLocaleString()}`,
                logo: '/static/genius.png'
              });
              setDropdownOpen(false);
            }}>
                <div className='flex items-center justify-between w-full'>
                  <div className='flex items-center'>
                    <Image src={selectedNetwork.logo || '/static/genius.png'} width={16} height={16} alt={`${selectedNetwork.name} logo`} className='mr-2' data-sentry-element="Image" data-sentry-source-file="DTPortfolioHeader.tsx" />
                    <span className='text-[14px]'>
                      All Networks
                    </span>
                  </div>
                  {selectedNetwork?.name === 'All Networks' && <GoCheck className='h-4 w-4 ml-4' />}
                </div>
              </li>

              {sortedNetworks.map(network => <li key={network?.networkName || 'all-networks'} className='px-4 cursor-pointer hover:bg-genius-blue flex justify-between items-center h-[45px]' onClick={() => {
              setSelectedNetwork({
                name: network?.networkName || 'All Networks',
                value: `$${network?.totalUsdValue?.toFixed(2)}`,
                logo: network?.networkLogo
              });
              setDropdownOpen(false);
            }}>
                  <div className='flex items-center'>
                    {network?.networkLogo ? <ImageWithFallback src={network?.networkLogo} width={20} height={20} alt={`${network?.networkName} logo`} className='mr-4 w-[20px] h-[20px]' /> : <Image src={'/static/genius.png'} width={20} height={20} alt={`${network?.networkName} logo`} className='mr-4 w-[20px] h-[20px]' />}

                    <span className='uppercase text-[14px]'>
                      {network?.networkName === 'eth-mainnet' ? 'Ethereum' : network?.networkName?.replace('-mainnet', '')}
                    </span>
                  </div>
                  {selectedNetwork?.name === network?.networkName && <GoCheck className='h-4 w-4 ml-4' />}
                </li>)}
            </ul>
          </ScrollArea>
        </div>
      </CustomDialog>
    </div>;
};